// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainRelatiesTitulatuurcodeType =
  (typeof SUREbusinessCommonDomainRelatiesTitulatuurcodeType)[keyof typeof SUREbusinessCommonDomainRelatiesTitulatuurcodeType];

export const SUREbusinessCommonDomainRelatiesTitulatuurcodeType = {
  HeerMevrouw: 'HeerMevrouw',
  Heer: 'Heer',
  Mevrouw: 'Mevrouw',
} as const;
